import { render, staticRenderFns } from "./MultipleLanguage.vue?vue&type=template&id=1d73aa06&scoped=true"
import script from "./MultipleLanguage.vue?vue&type=script&lang=js"
export * from "./MultipleLanguage.vue?vue&type=script&lang=js"
import style0 from "./MultipleLanguage.vue?vue&type=style&index=0&id=1d73aa06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73aa06",
  null
  
)

export default component.exports